import { DolbyMillicastPlayer } from '@optools/components/players/dolby-millicast-player';
import { useState } from 'react';

import {
  DolbyMillicastSourceForm,
  DolbyMillicastSourceFormType,
} from './dolby-millicast-source-form';

export function DolbyMillicastCardContent() {
  const [playerSource, setPlayerSource] = useState<DolbyMillicastSourceFormType | undefined>(
    undefined,
  );
  const handleSubmit = (values: DolbyMillicastSourceFormType) => {
    setPlayerSource(values);
  };

  return (
    <div className="flex flex-col gap-4 p-2">
      <DolbyMillicastSourceForm onSubmit={handleSubmit} />
      {playerSource ? (
        <DolbyMillicastPlayer
          streamAccountId={playerSource.streamAccountId}
          streamName={playerSource.streamName}
          subscriberToken={playerSource.subscriberToken}
        />
      ) : (
        <div className="flex aspect-video h-full w-full items-center justify-center rounded-lg bg-muted">
          <h3 className="text-sm font-medium text-muted-foreground">
            Enter Player Source to View Playback
          </h3>
        </div>
      )}
    </div>
  );
}
